module.exports = {"recipes":["recept_id_1","recept_id_2","recept_id_3","recept_id_4","recept_id_5","recept_id_6","recept_id_7","recept_id_8","recept_id_9","recept_id_10"]}


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/recipes.json
// module id = 987
// module chunks = 3